module.exports = __webpack_public_path__ + "static/media/slide-3.35b3c1bd.jpg";